import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ShareLink from '../shared/ShareLink'
import * as CompositeOptions from '../../constants/CompositeOptions';
import * as compositeSettingsActions from '../../actions/compositeSettingsActions';
import * as webrtcMeetingActions from '../../actions/webrtcMeetingActions';
import * as PublishOptions from '../../constants/PublishOptions';
import * as PublishSettingsActions from '../../actions/publishSettingsActions';
import { getCookieValues, setCookieValues } from '../../utils/CookieUtils';
import CookieName from '../../constants/CookieName';
import QueryString from 'query-string';
import muteImage from '../../images/mic-32px.svg'
import unmuteImage from '../../images/mic-off-32px.svg'
import videoImage from '../../images/videocam-32px.svg'
import videoOffImage from '../../images/videocam-off-32px.svg'

const hopUrlParameters = ['signalingURL', 'applicationName', 'streamName', 'audioBitrate', 'videoBitrate', 'videoCodec', 'videoTrack1DeviceId', 'videoTrack2DeviceId', 'audioTrackDeviceId', 'layout'];
const hopUrlParametersPrefix = 'hop.';

const HopSettingsForm = () => {

  const dispatch = useDispatch();
  const publishSettings = useSelector ((state) => state.publishSettings);
  const webrtcMeeting = useSelector ((state) => state.webrtcMeeting);
  const { cameras, microphones } = useSelector ((state) => state.media);
  const compositeSettings = useSelector ((state) => state.compositeSettings);
  const [ initialized, setInitialized ] = useState(false);

  // Load settings from cookie and URL on mount
  useEffect(() => {

    let cookieValues = getCookieValues(CookieName);
    let qs = QueryString.parse(window.location.search);
    let savedValues = { ...cookieValues, ...qs };

    for (let param in savedValues)
    {
      switch(param)
      {
        case (hopUrlParametersPrefix+'signalingURL'):
          dispatch({type:PublishSettingsActions.SET_PUBLISH_SIGNALING_URL,signalingURL:savedValues[param]});
          break;
        case (hopUrlParametersPrefix+'applicationName'):
          dispatch({type:PublishSettingsActions.SET_PUBLISH_APPLICATION_NAME,applicationName:savedValues[param]});
          break;
        case (hopUrlParametersPrefix+'streamName'):
            dispatch({type:PublishSettingsActions.SET_PUBLISH_STREAM_NAME,streamName:savedValues[param]});
            break;
        case (hopUrlParametersPrefix+'audioBitrate'):
            dispatch({type:PublishSettingsActions.SET_PUBLISH_AUDIO_BITRATE,audioBitrate:savedValues[param]});
            break;
        case (hopUrlParametersPrefix+'videoBitrate'):
            dispatch({type:PublishSettingsActions.SET_PUBLISH_VIDEO_BITRATE,videoBitrate:savedValues[param]});
            break;
        case (hopUrlParametersPrefix+'videoCodec'):
            dispatch({type:PublishSettingsActions.SET_PUBLISH_VIDEO_CODEC,videoCodec:savedValues[param]});
            break;
        case (hopUrlParametersPrefix+'videoTrack1DeviceId'):
          dispatch({type:compositeSettingsActions.SET_COMPOSITE_VIDEO_TRACK1_DEVICEID,videoTrack1DeviceId:savedValues[param]});
          break;
        case (hopUrlParametersPrefix+'videoTrack2DeviceId'):
          dispatch({type:compositeSettingsActions.SET_COMPOSITE_VIDEO_TRACK2_DEVICEID,videoTrack2DeviceId:savedValues[param]});
          break;
        case (hopUrlParametersPrefix+'audioTrackDeviceId'):
          dispatch({type:compositeSettingsActions.SET_COMPOSITE_AUDIO_TRACK_DEVICEID,audioTrackDeviceId:savedValues[param]});
          break;
        case (hopUrlParametersPrefix+'layout'):
          dispatch({type:compositeSettingsActions.SET_COMPOSITE_LAYOUT,layout:parseInt(savedValues[param])});
          break;
        default:
      }
    }
    setInitialized(true);
  },[dispatch]);

  // Save values to Cookie
  useEffect(() => {
    if (!initialized) return;
    let cookieValues = getCookieValues(CookieName);
    let settings = {...publishSettings, ...compositeSettings};
    for (let i = 0; i < hopUrlParameters.length; i++)
    {
      if (settings[hopUrlParameters[i]] != null)
      {
        cookieValues[hopUrlParametersPrefix+hopUrlParameters[i]] = settings[hopUrlParameters[i]];
      }
    }
    setCookieValues(CookieName,cookieValues);
  },[publishSettings, compositeSettings, initialized]);

  if (!initialized)
    return null;

  return (
    <div className="col-md-4 col-sm-12" id="meeting-settings">
      <form id="hop-settings-form">
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label htmlFor="signalingURL">Signaling URL</label>
              <input type="text"
                className="form-control"
                id="signalingURL"
                name="signalingURL"
                maxLength="1024"
                placeholder="wss://[ssl-certificate-domain-name]/webrtc-session.json"
                value={publishSettings.signalingURL}
                onChange={(e)=>dispatch({type:PublishSettingsActions.SET_PUBLISH_SIGNALING_URL,signalingURL:e.target.value})}
            />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="applicationName">Application Name</label>
              <input type="text"
                className="form-control"
                id="applicationName"
                name="applicationName"
                maxLength="256"
                value={publishSettings.applicationName}
                onChange={(e)=>dispatch({type:PublishSettingsActions.SET_PUBLISH_APPLICATION_NAME,applicationName:e.target.value})}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="meetingStreamName">Stream Name</label>
              <input type="text"
                className="form-control"
                id="meetingStreamName"
                name="meetingStreamName"
                maxLength="256"
                value={publishSettings.streamName}
                onChange={(e)=>dispatch({type:PublishSettingsActions.SET_PUBLISH_STREAM_NAME,streamName:e.target.value})}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="audioBitrate">Audio Bitrate</label>
              <div className="input-group">
                <input type="number"
                  className="form-control"
                  id="audioBitrate"
                  name="audioBitrate"
                  value={publishSettings.audioBitrate}
                  onChange={(e)=>dispatch({type:PublishSettingsActions.SET_PUBLISH_AUDIO_BITRATE,audioBitrate:e.target.value})}
                  />
                <div className="input-group-append">
                  <span className="input-group-text">Kbps</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="audioCodec">Audio Codec</label>
              <div className="input-group">
                <select className="form-control" id="audioCodec" name="audioCodec" value="opus" readOnly>
                  <option value="opus">Opus</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="videoBitrate">Video Bitrate</label>
              <div className="input-group">
                <input type="number"
                  className="form-control"
                  id="videoBitrate"
                  name="videoBitrate"
                  value={publishSettings.videoBitrate}
                  onChange={(e)=>dispatch({type:PublishSettingsActions.SET_PUBLISH_VIDEO_BITRATE,videoBitrate:e.target.value})}
                />
                <div className="input-group-append">
                  <span className="input-group-text">Kbps</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="videoCodec">Video Codec</label>
              <div className="input-group">
                <select className="form-control"
                  id="videoCodec"
                  name="videoCodec"
                  value={publishSettings.videoCodec}
                  onChange={(e)=>dispatch({type:PublishSettingsActions.SET_PUBLISH_VIDEO_CODEC,videoCodec:e.target.value})}
                >
                  { PublishOptions.videoCodecs.map((codec,key) => {
                    return <option key={key} value={codec.value}>{codec.name}</option>
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label htmlFor="video-track1-select">
                Video Input 1
              </label>
              <select id="video-track1-select" className="form-control"
                value={compositeSettings.videoTrack1DeviceId}
                onChange={(e)=>dispatch({type:compositeSettingsActions.SET_COMPOSITE_VIDEO_TRACK1_DEVICEID,videoTrack1DeviceId:e.target.value})}
              >
                <option value=''>None</option>
                { cameras.map((cam,key) => {
                  return <option key={key} value={cam.deviceId}>{cam.label}</option>
                })}
                <option value='screen'>Screen Share</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label htmlFor="video-track2-select">
                Video Input 2
              </label>
              <select id="video-track2-select" className="form-control"
                value={compositeSettings.videoTrack2DeviceId}
                onChange={(e)=>dispatch({type:compositeSettingsActions.SET_COMPOSITE_VIDEO_TRACK2_DEVICEID,videoTrack2DeviceId:e.target.value})}
              >
                <option value=''>None</option>
                { cameras.map((cam,key) => {
                  return <option key={key} value={cam.deviceId}>{cam.label}</option>
                })}
              </select>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-10">
            <div className="form-group">
              <label htmlFor="mic-list-select">
                Audio Input
              </label>
              <select id="mic-list-select" className="form-control"
                value={compositeSettings.audioTrackDeviceId}
                onChange={(e)=>dispatch({type:compositeSettingsActions.SET_COMPOSITE_AUDIO_TRACK_DEVICEID,audioTrackDeviceId:e.target.value})}
              >
                <option value=''>None</option>
                { microphones.map((mic,key) => {
                  return <option key={key} value={mic.deviceId}>{mic.label}</option>
                })}
              </select>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <label>Layout</label>
            <div className="row composite-layout text-center">
              <div className="col-lg-3 col-md-4 col-4 mb-2">
                <button type="button"
                  className={"btn composite-layout-button" + (compositeSettings.layout === 0 ? " btn-outline-warning" : " btn-outline-secondary") }
                  onClick={(e)=>dispatch({type:compositeSettingsActions.SET_COMPOSITE_LAYOUT,layout:0})}>
                    <span className="composite-layout-button-label">1</span>
                </button>
              </div>
              <div className="col-lg-3 col-md-4 col-4 mb-2">
                <button type="button"
                  className={"btn composite-layout-button" + (compositeSettings.layout === 1 ? " btn-outline-warning" : " btn-outline-secondary") }
                  onClick={(e)=>dispatch({type:compositeSettingsActions.SET_COMPOSITE_LAYOUT,layout:1})}>
                    <span className="composite-layout-button-label">2</span>
                </button>
              </div>
              <div className="col-lg-3 col-md-4 col-4 mb-2">
                <button type="button"
                  className={"btn composite-layout-button" + (compositeSettings.layout === 2 ? " btn-outline-warning" : " btn-outline-secondary") }
                  onClick={(e)=>dispatch({type:compositeSettingsActions.SET_COMPOSITE_LAYOUT,layout:2})}>
                    <div className="composite-layout-pip pip-top-right">2</div>
                    <span className="composite-layout-button-label">1</span>
                </button>
              </div>
              <div className="col-lg-3 col-md-4 col-4 mb-2">
                <button type="button"
                  className={"btn composite-layout-button" + (compositeSettings.layout === 3 ? " btn-outline-warning" : " btn-outline-secondary") }
                  onClick={(e)=>dispatch({type:compositeSettingsActions.SET_COMPOSITE_LAYOUT,layout:3})}>
                    <div className="composite-layout-pip pip-top-right">1</div>
                    <span className="composite-layout-button-label">2</span>
                </button>
              </div>
              <div className="col-lg-3 col-md-4 col-4 mb-2">
                <button type="button"
                  className={"btn composite-layout-button" + (compositeSettings.layout === 4 ? " btn-outline-warning" : " btn-outline-secondary") }
                  onClick={(e)=>dispatch({type:compositeSettingsActions.SET_COMPOSITE_LAYOUT,layout:4})}>
                    <div className="composite-layout-pip pip-top-left">2</div>
                    <span className="composite-layout-button-label">1</span>
                </button>
              </div>
              <div className="col-lg-3 col-md-4 col-4 mb-2">
                <button type="button"
                  className={"btn composite-layout-button" + (compositeSettings.layout === 5 ? " btn-outline-warning" : " btn-outline-secondary") }
                  onClick={(e)=>dispatch({type:compositeSettingsActions.SET_COMPOSITE_LAYOUT,layout:5})}>
                    <div className="composite-layout-pip pip-bottom-left">2</div>
                    <span className="composite-layout-button-label">1</span>
                </button>
              </div>
              <div className="col-lg-3 col-md-4 col-4 mb-2">
                <button type="button"
                  className={"btn composite-layout-button" + (compositeSettings.layout === 6 ? " btn-outline-warning" : " btn-outline-secondary") }
                  onClick={(e)=>dispatch({type:compositeSettingsActions.SET_COMPOSITE_LAYOUT,layout:6})}>
                    <div className="composite-layout-pip pip-bottom-right">2</div>
                    <span className="composite-layout-button-label">1</span>
                </button>
              </div>
              <div className="col-lg-3 col-md-4 col-4 mb-2">
                <button type="button"
                  className={"btn composite-layout-button" + (compositeSettings.layout === 7 ? " btn-outline-warning" : " btn-outline-secondary") }
                  onClick={(e)=>dispatch({type:compositeSettingsActions.SET_COMPOSITE_LAYOUT,layout:7})}>
                    <div className="composite-layout-quarter quarter-left">1</div>
                    <div className="composite-layout-quarter quarter-right">2</div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <label>Bố cục người tham gia</label>
            <div className="row text-center">
              <div className="col-4 mb-2">
                <button
                  type="button"
                  className={"btn btn-block" + (webrtcMeeting.peerVideoLayout === 'auto' ? " btn-warning" : " btn-secondary")}
                  onClick={() => dispatch({ type: webrtcMeetingActions.SET_PEER_VIDEO_LAYOUT, peerVideoLayout: 'auto' })}>
                    Tự động
                </button>
              </div>
              <div className="col-4 mb-2">
                <button
                  type="button"
                  className={"btn btn-block" + (webrtcMeeting.peerVideoLayout === 'grid-2x2' ? " btn-warning" : " btn-secondary")}
                  onClick={() => dispatch({ type: webrtcMeetingActions.SET_PEER_VIDEO_LAYOUT, peerVideoLayout: 'grid-2x2' })}>
                    Lưới 2x2
                </button>
              </div>
              <div className="col-4 mb-2">
                <button
                  type="button"
                  className={"btn btn-block" + (webrtcMeeting.peerVideoLayout === 'grid-3x3' ? " btn-warning" : " btn-secondary")}
                  onClick={() => dispatch({ type: webrtcMeetingActions.SET_PEER_VIDEO_LAYOUT, peerVideoLayout: 'grid-3x3' })}>
                    Lưới 3x3
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-auto text-center">
            <button id="camera-toggle" type="button" className="control-button" onClick={() => dispatch({type:PublishSettingsActions.TOGGLE_VIDEO_ENABLED})}>
              <img alt="" className="noll" id="video-off" src={videoImage} style={{display:((publishSettings.videoTrack && publishSettings.videoTrack.enabled)?"inline":"none")}}/>
              <img alt="" className="noll" id="video-on" src={videoOffImage} style={{display:((!publishSettings.videoTrack || !publishSettings.videoTrack.enabled)?"inline":"none")}}/>
            </button>
            <button id="mute-toggle" type="button" className="control-button" onClick={(e) => dispatch({type:PublishSettingsActions.TOGGLE_AUDIO_ENABLED})}>
              <img alt="" className="noll" id="mute-off" src={muteImage} style={{display:((publishSettings.audioTrack && publishSettings.audioTrack.enabled)?"inline":"none")}} />
              <img alt="" className="noll" id="mute-on" src={unmuteImage} style={{display:((publishSettings.audioTrack && publishSettings.audioTrack.enabled)?"none":"inline")}}/>
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-10">
            { !webrtcMeeting.connected &&
              <button id="meeting-toggle" type="button" className="btn"
                disabled={publishSettings.publishStarting }
                // join the meeting
                onClick={(e)=>dispatch(PublishSettingsActions.startPublish())}
              >Join</button>
            }
            { webrtcMeeting.connected &&
              <button id="meeting-toggle" type="button" className="btn"
                // leave the meeting
                onClick={(e)=>dispatch(PublishSettingsActions.stopPublish())}
              >Leave</button>
            }
          </div>
          <div className="col-2">
            <ShareLink settings={{...publishSettings, ...compositeSettings}} parameters={hopUrlParameters} prefix={hopUrlParametersPrefix} />
          </div>
        </div>
      </form>
    </div>
  );
}

export default HopSettingsForm;
